import styled from 'styled-components'
import React, { useState, useEffect } from 'react'

const StyledVideo = styled.video.attrs({controls:true})`
    width:10em;
    height:10em;
`

export default StyledVideo